const ROLE_LABELS = {
  ADMIN: "Admin",
  TEAM_LEAD: "Team Lead",
  RECRUITER: "Recruiter",
};

// Turns "TEAM_LEAD" -> "Team Lead", "RECRUITER" -> "Recruiter". Falls back
// to the raw value (or "-") if it's ever something we don't recognize.
export const roleLabel = (role) => ROLE_LABELS[role] || role || "-";

// Date only — e.g. for a table cell where the exact time isn't the point.
export const formatDate = (value) => (value ? new Date(value).toLocaleDateString() : "-");

// Date + time — used everywhere an "Added On" column needs to show not
// just the day but the time of day the record was created.
export const formatDateTime = (value) => (value ? new Date(value).toLocaleString() : "-");

// "John Smith (Recruiter)" — the common "who added this" label used in
// Added By columns/rows. Accepts either a populated user object
// ({ name, role }) or nothing (renders "-").
export const addedByLabel = (user) => {
  if (!user?.name) return "-";
  return `${user.name} (${roleLabel(user.role)})`;
};
